import { useContext } from 'react';
import { DatasetFormDataContext } from '../../context/DatasetFormDataContext/DatasetFormDataContext';
import { UseDatasetFormDataReturnType } from '../../types/context';

export const useDatasetFormData = (): UseDatasetFormDataReturnType => {
  const context = useContext(DatasetFormDataContext);

  if (context.isProvided === false) {
    throw new Error(
      'useDataForm must be used within a DatasetFormDataContextProvider'
    );
  }

  return context;
};

// Safe variant — returns null when called outside DatasetFormDataContextProvider.
// Use when the hook may run in both form and non-form contexts (e.g. GridInput).
export const useDatasetFormDataOptional = (): UseDatasetFormDataReturnType | null => {
  const context = useContext(DatasetFormDataContext);
  return context.isProvided ? context : null;
};
